"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/observable/of");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/first");
require("rxjs/add/operator/map");
require("rxjs/add/operator/merge");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/share");
require("rxjs/add/operator/startWith");
var CacheService = /** @class */ (function () {
    function CacheService(ngZone, platformId) {
        this.ngZone = ngZone;
        this.platformId = platformId;
        this.$store = {};
        this.$changes = new Subject_1.Subject();
        this.$expirations = [];
        this.changes = this.$changes.asObservable().share();
    }
    CacheService.prototype.has = function (key) {
        return this.$store.hasOwnProperty(key);
    };
    CacheService.prototype.get = function (key) {
        return CacheValueObservable.create(this, key);
    };
    CacheService.prototype.set = function (key, value, expires) {
        expires = this.normalizeExpires(expires);
        this.$store[key] = { value: value, expires: expires };
        this.addToExpirationQueue(key, expires);
        this.$changes.next({ type: "set", key: key, value: value, expires: expires });
        return this;
    };
    CacheService.prototype.delete = function (key) {
        var entry = this.$store[key];
        if (entry) {
            delete this.$store[key];
            var value = entry.value, expires = entry.expires;
            this.$changes.next({ type: "delete", key: key, value: value, expires: expires });
        }
        return this;
    };
    CacheService.prototype.serialize = function () {
        return JSON.stringify(this.$store);
    };
    CacheService.prototype.deserialize = function (json) {
        var _this = this;
        var data = JSON.parse(json);
        Object.keys(data).forEach(function (key) {
            var _a = data[key], value = _a.value, expires = _a.expires;
            _this.set(key, value, expires);
        });
    };
    /**
     * @returns number of milliseconds elapsed since 1 January 1970 00:00:00 UTC
     */
    CacheService.prototype.normalizeExpires = function (expires) {
        if (typeof expires === "number") {
            if (expires < 0) {
                // never expires
                return -1;
            }
            else if (expires < 365 * 24 * 60 * 60 * 1000) {
                // treat small numbers (less than 1 year) as relative time
                return Date.now() + expires;
            }
            else {
                // treat big numbers as absolute time
                return expires;
            }
        }
        else if (typeof expires === "string") {
            if (!/^\d+(ms|s|m|h|d)?$/.test(expires)) {
                throw new Error("invalid expires value \"" + expires + "\"");
            }
            var numeral = parseInt(expires.slice(0, -1));
            var unit = expires.slice(-1);
            switch (unit) {
                case "ms":
                    return Date.now() + numeral;
                case "s":
                    return Date.now() + numeral * 1000;
                case "m":
                    return Date.now() + numeral * 60 * 1000;
                case "h":
                    return Date.now() + numeral * 60 * 60 * 1000;
                case "d":
                    return Date.now() + numeral * 24 * 60 * 60 * 1000;
                default:
                    // shoult not hit here
                    throw new Error("unknown error");
            }
        }
        else {
            return -1;
        }
    };
    CacheService.prototype.addToExpirationQueue = function (key, expires) {
        // no need to check expiration on server side
        if (common_1.isPlatformServer(this.platformId))
            return;
        // if the key is already in queue, remove it
        var duplicateIndex = this.$expirations.findIndex(function (item) { return item.key === key; });
        if (duplicateIndex >= 0)
            this.$expirations.splice(duplicateIndex, 1);
        if (duplicateIndex === 0 && this.$timer)
            this.clearTimer();
        // if expires is set, insert it to the queue ordered by expires
        if (expires > 0) {
            var insertIndex = this.$expirations.findIndex(function (item) { return item.expires > expires; });
            if (insertIndex < 0)
                insertIndex = this.$expirations.length;
            this.$expirations.splice(insertIndex, 0, { key: key, expires: expires });
            if (insertIndex === 0 && this.$timer)
                this.clearTimer();
        }
        // trigger timer if needed
        if (this.$expirations.length > 0 && !this.$timer)
            this.triggerExpirationTimer();
    };
    CacheService.prototype.triggerExpirationTimer = function () {
        var _this = this;
        if (this.$expirations.length > 0 && !this.$timer) {
            var delay = this.$expirations[0].expires - Date.now();
            this.setTimer(delay, function () {
                _this.removeExpiredEntries();
                _this.triggerExpirationTimer();
            });
        }
    };
    CacheService.prototype.removeExpiredEntries = function () {
        while (this.$expirations.length > 0) {
            var _a = this.$expirations[0], key = _a.key, expires = _a.expires;
            if (Date.now() < expires)
                break;
            this.$expirations.shift();
            var value = this.$store[key].value;
            delete this.$store[key];
            this.$changes.next({ type: "expire", key: key, value: value, expires: expires });
        }
    };
    CacheService.prototype.setTimer = function (delay, task) {
        var _this = this;
        // run timer outside of angular zone so that it won't block protractor
        this.ngZone.runOutsideAngular(function () {
            _this.$timer = setTimeout(function () {
                _this.$timer = undefined;
                _this.ngZone.run(task);
            }, delay);
        });
    };
    CacheService.prototype.clearTimer = function () {
        if (this.$timer)
            clearTimeout(this.$timer);
        this.$timer = undefined;
    };
    CacheService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    CacheService.ctorParameters = function () { return [
        { type: core_1.NgZone, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [core_1.PLATFORM_ID,] },] },
    ]; };
    return CacheService;
}());
exports.CacheService = CacheService;
////////////
var CacheValueObservable = /** @class */ (function (_super) {
    __extends(CacheValueObservable, _super);
    function CacheValueObservable(cache, key) {
        var _this = _super.call(this) || this;
        _this.cache = cache;
        _this.key = key;
        return _this;
    }
    CacheValueObservable.create = function (cache, key) {
        var observable = new CacheValueObservable(cache, key);
        var changes = cache.changes
            .filter(function (event) { return event.type === "set" && event.key === key; })
            .map(function (event) { return event.value; });
        if (cache.has(key)) {
            var initialValue = cache.$store[key].value;
            observable.source = changes.startWith(initialValue);
        }
        else {
            observable.source = changes;
        }
        return observable;
    };
    CacheValueObservable.prototype.miss = function (fetch) {
        var observable = new CacheValueObservable(this.cache, this.key);
        observable.source = this;
        observable.operator = new CacheValueMissOperator(this.cache, this.key, fetch);
        return observable;
    };
    CacheValueObservable.prototype.expires = function (callback) {
        var _this = this;
        var observable = new CacheValueObservable(this.cache, this.key);
        observable.source = this.cache.changes
            .filter(function (event) { return event.type === "expire" && event.key === _this.key; })
            .map(function (event) { return callback(event.value); })
            .flatMap(function (value) {
            if (isObservable(value)) {
                return value.first();
            }
            else if (isPromise(value)) {
                return Observable_1.Observable.fromPromise(value);
            }
            else {
                return Observable_1.Observable.of(value);
            }
        })
            .merge(this);
        return observable;
    };
    CacheValueObservable.prototype.current = function () {
        if (this.cache.has(this.key)) {
            return this.cache.$store[this.key].value;
        }
        else {
            return undefined;
        }
    };
    return CacheValueObservable;
}(Observable_1.Observable));
exports.CacheValueObservable = CacheValueObservable;
var CacheValueMissOperator = /** @class */ (function () {
    function CacheValueMissOperator(cache, key, fetch) {
        this.cache = cache;
        this.key = key;
        this.fetch = fetch;
    }
    CacheValueMissOperator.prototype.call = function (subscriber, source) {
        var _this = this;
        var cache = this.cache;
        var key = this.key;
        var fetch = this.fetch;
        var fetchingKey = "CacheService:Fetching:" + key;
        if (!this.cache.has(this.key) && !this.cache.has(fetchingKey)) {
            this.cache.set(fetchingKey, true);
            var expires_1;
            var onResolve = function (value) {
                // this must be async for subscribers to receive this value
                Promise.resolve().then(function () {
                    if (typeof expires_1 === "function") {
                        expires_1 = expires_1(value);
                    }
                    _this.cache.delete(fetchingKey);
                    _this.cache.set(key, value, expires_1);
                });
            };
            var onError = function (err) {
                _this.cache.delete(fetchingKey);
                subscriber.error(err);
            };
            var fetchResult = void 0;
            try {
                fetchResult = fetch();
            }
            catch (err) {
                return onError(err);
            }
            var fetchResultValue = void 0;
            if (isFetchResultValueWithOptions(fetchResult)) {
                fetchResultValue = fetchResult.value;
                expires_1 = fetchResult.expires;
            }
            else {
                fetchResultValue = fetchResult;
                expires_1 = -1;
            }
            if (isObservable(fetchResultValue)) {
                fetchResultValue.first().subscribe(onResolve, onError);
            }
            else if (isPromise(fetchResultValue)) {
                fetchResultValue.then(onResolve, onError);
            }
            else {
                onResolve(fetchResultValue);
            }
        }
        return source._subscribe(subscriber);
    };
    return CacheValueMissOperator;
}());
exports.CacheValueMissOperator = CacheValueMissOperator;
////////////
function isFetchResultValueWithOptions(obj) {
    return obj && obj.hasOwnProperty("value");
}
function isObservable(obj) {
    return obj && obj.subscribe;
}
function isPromise(obj) {
    return obj && obj.then;
}
//# sourceMappingURL=cache.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/obscache/dist/cache.service.js
// module id = 110
// module chunks = 0